// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msg-type-icon{width:16px;height:16px}`, "",{"version":3,"sources":["webpack://./src/components/MsgTypeIcon/style.scss"],"names":[],"mappings":"AACA,eACE,UAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
